// extracted by mini-css-extract-plugin
export default {"recos":"D3-z","productCardOverride":"E3-z","rowHasBadge":"F3-z"};